import { FadeUp } from "@/components/motion/Reveal";

export function SectionHeading({ index, label, title, sub, dark = false }) {
  return (
    <div className="mb-14 max-w-3xl md:mb-20">
      <FadeUp>
        <p
          className={`mb-5 flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] ${
            dark ? "text-white/60" : "text-navy/60"
          }`}
          data-testid={`section-label-${label?.toLowerCase().replace(/\s+/g, "-")}`}
        >
          <span className="text-brand">{index}</span>
          <span className={`h-px w-10 ${dark ? "bg-white/30" : "bg-navy/30"}`} />
          {label}
        </p>
      </FadeUp>
      <FadeUp delay={0.1}>
        <h2
          className={`font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl ${
            dark ? "text-white" : "text-navy"
          }`}
        >
          {title}
        </h2>
      </FadeUp>
      {sub && (
        <FadeUp delay={0.2}>
          <p className={`mt-5 max-w-2xl text-base leading-relaxed md:text-lg ${dark ? "text-white/70" : "text-muted-foreground"}`}>
            {sub}
          </p>
        </FadeUp>
      )}
    </div>
  );
}
